import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import { v4 as uuidv4 } from "uuid";

dayjs.extend(utc);
dayjs.extend(relativeTime);

export type Id = string;

export interface WishlistItem {
  id: Id;
  name: string;
  link: string | null;
  price: string | null;
  currency: string;
  createdAt: string;
  updatedAt: string;
  description: string | null;
  imageLink: string | null;
}

export interface Wishlist {
  id: Id;
  userId: Id;
  name: string;
  updatedAt: string;
  items: WishlistItem[];
}

export interface User {
  id: Id;
  name: string;
}

export function makeItem(): WishlistItem {
  return {
    id: uuidv4(),
    name: "",
    description: "",
    imageLink: "",
    link: "",
    price: "",
    currency: "USD",
    createdAt: dayjs().toISOString(),
    updatedAt: dayjs().toISOString(),
  };
}

export function makeWishlist(userId: Id): Omit<Wishlist, "id"> {
  return {
    userId,
    name: "[default]",
    updatedAt: dayjs().toISOString(),
    items: [],
  };
}

export interface Reserved {
  wishlistId: Id;
  wishId: Id;
  userId: Id;
}

export enum NotificationType {
  FriendAdded = "FriendAdded",
  FriendAddedWish = "FriendAddedWish",
}

export interface WishNotification {
  wishId?: Id;
  wishImageUrl?: string;
  wishName?: string;
}

export interface Notification {
  id: Id;
  createdAt: string;
  sourceUserId: Id;
  type: NotificationType;
  wishlistId?: Id;
  wishes?: WishNotification[];
  consumed: boolean;
}

export interface NotificationView extends Notification {
  sourceUserDisplayName: string;
}
